import * as logging from "./logging";
import * as $ from "jquery";

import * as dust from 'dustjs-linkedin/lib/dust';
import 'dustjs-linkedin/lib/compiler';
import 'dustjs-helpers/dist/dust-helpers';


declare var appPath: any;

 

$(() => {
    const log = new logging.Log("Behaviors");

    $(document).on("click", "*[data-toggleanswers]", function (event) {

        $(this).closest(".row").toggleClass("open");

        var elementName = ($(this).attr("data-toggleanswers"))
         
        $("#" + elementName).toggle();

        return true;
    });


    $("#F3StatementOfPigBreedingOmitted").on('click', function (event) {
        if (!$('#F3StatementOfPigBreedingTrue').prop('disabled')) {
            $("#F3StatementOfPigBreedingTrue").prop('disabled', true)
            $("#F3StatementOfPigBreedingFalse").prop('disabled', true)

            $("#F3StatementOfPigBreedingTrue").prop('checked', false);
            $("#F3StatementOfPigBreedingFalse").prop('checked', false);
        }
        else {
            $("#F3StatementOfPigBreedingTrue").prop('disabled', false)
            $("#F3StatementOfPigBreedingFalse").prop('disabled', false)
        }
        return;
    });


    $(document).submit(function () {
        //$("input[type='submit']").prop('disabled', true);
        $("*[data-disableButton]").prop('disabled', true);
        return true;
        
    });



    $(document).on("keypress", "*[data-OnlyNumberKey]", function (event) {

        var ASCIICode = (event.which) ? event.which : event.keyCode
        if (ASCIICode > 31 && (ASCIICode < 48 || ASCIICode > 57))
            return false;
        return true;
    });

    $(document).on("keyup", "*[data-SubmitOnEnter]", function (event) {

        if (event.keyCode === 13) {
            event.preventDefault();
            $("#PublicSearchButton").click();
        }
    });

    $("#PublicSearchButton").on('click', function (event) {
        event.preventDefault();

        let searchText = $("#SearchText").val();

        let animalTypeCode = $("input[type='radio'][name='AnimalTypeCode']:checked").val();
       
        var param = '{ "search":"' + searchText + '", "animalTypeCode":"' + animalTypeCode + '" }';

        $.ajax({
            type: "POST",
            url: appPath + "api/Search",
            data: param,
            cache:false,
            contentType: "application/json; charset=utf-8",
            dataType: "json"
        })
            .done(function (data, textStatus, jqXHR) {
                RenderReports(data);
     
                console.log("Counter ");
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
     
                console.log("Uventet fejl: " + errorThrown + " (" + textStatus + ")");
            });
    
        return true;
    });


    $("#PrivateSearchButton").on('click', function (event) {
        event.preventDefault();

        var param = '';

        $.ajax({
            type: "POST",
            url: appPath + "api/SearchByUser",
            data: param,
            cache: false,
            contentType: "application/json; charset=utf-8",
            dataType: "json"
        })
            .done(function (data, textStatus, jqXHR) {
                RenderReports(data);

                console.log("Counter ");
            })
            .fail(function (jqXHR, textStatus, errorThrown) {

                console.log("Uventet fejl: " + errorThrown + " (" + textStatus + ")");
            });

        return true;
    });

    function RenderReports(reports) {
        console.log(reports);

        let errorMessage = "Der er sket en fejl";

        if (reports != "") {
            console.log(reports.herdStatus.length);
            if (reports.herdStatus.length > 0) {
                var src = document.getElementById('resultTemplate').textContent;

                var compiled = dust.compile(src, 'resultTemplate');

                dust.loadSource(compiled);

                dust.render('resultTemplate', reports, function (err, out) {
                    console.log(err);
                    $('#result').html(out);
                });

                return;
            }
            else {
                errorMessage = reports.errorMessage
            }

        }
        else {
            errorMessage = "Der er ikke modtaget data"
        }


        var src = document.getElementById('errorTemplate').textContent;

        var compiled = dust.compile(src, 'errorTemplate');

        dust.loadSource(compiled);

        dust.render('errorTemplate', { message: errorMessage }, function (err, out) {
            console.log(err);
            $('#result').html(out);
            
        });
        
    }


    //$(document).on("click", "*[data-confirm]", function (event) {
    //    if (!confirm($(this).attr("data-confirm"))) {
    //        event.preventDefault();
    //        event.stopImmediatePropagation();
    //        return false;
    //    }
    //});



    log.error("We are logging");

    // Enable Bootstrap tooltips
    $('body').tooltip({
        selector: '[data-bs-toggle=tooltip]'
    });

    
});